var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { connect } from "react-redux";
import { find } from "lodash";
import CopyToClipboard from "react-copy-to-clipboard";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import medicalTracking from "@irati-tracking/medical";
import ShowPopUp from "@irati/store/actions/ShowSuccessPopUp";
import OnboardingSteps from "@irati/onboarding/enums/Step";
import onboardingService from "@irati/onboarding/services/onboarding";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import isMobileDevice from "@irati/utils/mobile";
import { ACTIVATION_CODE } from "../../../constants/tracking";
import ActivationSteps from "../../../components/ActivationSteps";
import AppFeatures from "../../../components/AppFeatures";
import ContinueOnline from "../../../components/ContinueOnline";
import StepPage from "../../../components/StepPage";
import { TextMeInstructions } from "../../../components/shared";
import appScreen from "../../../images/appScreen.jpg";
import { Flex, CodeWrapper, Code, AppScreenImg, Description, TextMeInstructionsWrapper, TooltipAttach } from "./styled";
var TOOLTIP_ACTIVATION_CODE = "activationCode";
var ActivationCode = /** @class */ (function (_super) {
    __extends(ActivationCode, _super);
    function ActivationCode(props) {
        var _this = _super.call(this, props) || this;
        _this.popupTimeout = null;
        _this.completeStep = function (step) {
            var auth = _this.props.auth;
            onboardingService.completeStep(auth.user, step, auth.accessToken).then(function (onboarding) {
                _this.props.updateAuth(auth.user, onboarding);
            });
        };
        _this.handleContinueOnline = function () {
            medicalTracking.continueOnline(_this.props.user.activationCode, ACTIVATION_CODE);
        };
        medicalTracking.viewStep(3, props.user.activationCode);
        return _this;
    }
    ActivationCode.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, isTablet = _a.isTablet, showPopUp = _a.showPopUp, onboarding = _a.auth.onboarding;
        window.scrollTo(0, 0);
        var hasViewedMedicalActivationPage = find(onboarding.completedSteps, function (step) {
            return step === OnboardingSteps.HAS_VIEWED_MEDICAL_ACTIVATION_PAGE;
        });
        var hasHiddenMedicalActivationPageTooltip = find(onboarding.completedSteps, function (step) {
            return step === OnboardingSteps.HAS_HIDDEN_MEDICAL_ACTIVATION_PAGE;
        });
        if (!isTablet) {
            if (hasViewedMedicalActivationPage && !hasHiddenMedicalActivationPageTooltip) {
                var formatMessage = this.props.formatMessage;
                var tooltip = {
                    show: true,
                    text: formatMessage({ id: "medical.code.tooltip.text" }),
                    subtext: formatMessage({ id: "medical.tooltip.subtext" }),
                    anchor: TOOLTIP_ACTIVATION_CODE,
                    positionVertically: true,
                    height: 220,
                    leftTriangle: true,
                    onChange: function () { return _this.completeStep(OnboardingSteps.HAS_HIDDEN_MEDICAL_ACTIVATION_PAGE); }
                };
                showPopUp(tooltip);
                this.popupTimeout = setTimeout(function () {
                    showPopUp({ show: false });
                }, 10000);
            }
            else {
                this.completeStep(OnboardingSteps.HAS_VIEWED_MEDICAL_ACTIVATION_PAGE);
            }
        }
    };
    ActivationCode.prototype.componentWillUnmount = function () {
        if (this.popupTimeout) {
            clearTimeout(this.popupTimeout);
        }
        this.props.showPopUp({ show: false });
    };
    ActivationCode.prototype.componentDidUpdate = function () {
        var _a = this.props, isTablet = _a.isTablet, showPopUp = _a.showPopUp;
        if (isTablet) {
            showPopUp({ show: false });
        }
    };
    ActivationCode.prototype.render = function () {
        var isMobile = !!isMobileDevice();
        var _a = this.props.user, activationCode = _a.activationCode, phoneNumber = _a.phoneNumber;
        return (React.createElement(StepPage, { currentStep: 3, noPaddingBottom: true },
            !isMobile && React.createElement(Description, null,
                React.createElement(FormattedMessage, { id: "medical.activation.desktopStep.desc" })),
            React.createElement(ActivationSteps, { isMobile: isMobile }),
            React.createElement(CodeWrapper, null,
                React.createElement(Code, null,
                    isMobile
                        ? React.createElement(CopyToClipboard, { text: activationCode },
                            React.createElement(Para, { bold: true, large: true, flush: true }, activationCode))
                        : React.createElement(Para, { bold: true, large: true, flush: true }, activationCode),
                    React.createElement(TooltipAttach, { "data-attach-tooltip": TOOLTIP_ACTIVATION_CODE }))),
            React.createElement(Flex, null,
                React.createElement("div", null,
                    React.createElement(AppFeatures, null),
                    React.createElement(TextMeInstructionsWrapper, null,
                        React.createElement(TextMeInstructions, { phoneNumber: phoneNumber, activationCode: activationCode, trackingLocation: ACTIVATION_CODE })),
                    React.createElement(ContinueOnline, { onClick: this.handleContinueOnline, activationCode: activationCode, link: "medical.code.continueOnline.link.href", text: "medical.code.continueOnline.link.text", isGrey: true, isMarginLarge: true })),
                React.createElement(AppScreenImg, { src: appScreen }))));
    };
    return ActivationCode;
}(Component));
var mapStateToProps = function (state) {
    return {
        isTablet: state.mq.lessThan.large,
        auth: state.auth
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    showPopUp: function (options) { return dispatch(ShowPopUp(options)); },
    updateAuth: function (user, onboarding) { return dispatch(AuthActions.UpdateAuthAction({ user: user, onboarding: onboarding })); }
}); };
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActivationCode));
